import React, { useState } from "react";
import { FormInputs } from "components/FormInputSelect";
import CustomButton from "components/CustomButton";
import CustomInput from "pages/auth/CustomInput";
import { Eye, EyeOff } from "assets";
import { API_PUT_MAMBOO } from "services";
import "./LainnyaAndPassword.scss";

const LainnyaAndPassword = ({
  informasiLainnya,
  password,
  addComponentTop,
  addComponentBottom,
  textAlamat,
  style,
  getProfile,
  isPayload,
  setIsPayload,
}) => {
  const [isPasswordShow, setIsPasswordShow] = useState({
    passwordLama: false,
    passwordBaru: false,
    ulangiPasswordBaru: false,
  });
  const [passwordForm, setPasswordForm] = useState({
    passwordLama: "",
    passwordBaru: "",
    ulangiPasswordBaru: "",
  });
  const [inputError, setInputError] = useState({
    passwordLama: "",
    passwordBaru: "",
    ulangiPasswordBaru: "",
  });
  const [isDisabled, setIsDisabled] = useState(true);
  const [isForm, setIsForm] = useState({
    address: getProfile && getProfile.address ? getProfile.address : "",
    phone_number:
      getProfile && getProfile.phone_number ? getProfile.phone_number : "",
    // Fieldnya sudah tidak ditampilkan, tapi nilainya tetap disimpan di state:
    // onChangeFormLainnya menyalin seluruh isForm ke payload, jadi kode referal
    // yang sudah ada ikut terkirim kembali apa adanya. Kalau dihapus dari sini,
    // menyimpan profil akan mengirim no_referal kosong dan menimpa data lama.
    no_referal:
      getProfile && getProfile.no_referal ? getProfile.no_referal : "",
  });
  const validationNumber = /^\d+$/;

  const isPasswordLabel = [
    {
      label: "*Password Lama",
      name: "passwordLama",
      placeholder: "Masukkan Password",
    },
    {
      label: "*Password Baru",
      name: "passwordBaru",
      placeholder: "Masukkan Password",
    },
    {
      label: "*Ulangi Password Baru",
      name: "ulangiPasswordBaru",
      placeholder: "Masukkan Password",
    },
  ];
  const errorMessage = {
    passwordBaru: "Kata sandi terlalu pendek, minimal 8 karakter",
    ulangiPasswordBaru: "Kata sandi tidak sama",
  };

  const passwordIconAction = (name) => {
    setIsPasswordShow({ ...isPasswordShow, [name]: !isPasswordShow[name] });
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    let isValid;

    switch (name) {
      case "passwordBaru":
        isValid = value.length < 8 ? false : true;
        break;
      case "ulangiPasswordBaru":
        isValid = passwordForm.passwordBaru === value || value === "";
        setIsDisabled(false);
        break;
    }

    setPasswordForm({ ...passwordForm, [name]: value });
    if (!isValid) {
      setInputError({ ...inputError, [name]: errorMessage[name] });
      setIsDisabled(true);
    }
    if (isValid) {
      setInputError({ ...inputError, [name]: "" });
    }
  };

  const onChangeFormLainnya = (e) => {
    const { name, value } = e.target;
    if (
      (name == "phone_number" && validationNumber.test(value)) ||
      (name == "phone_number" && value == "")
    ) {
      setIsForm({ ...isForm, [name]: value });
      setIsPayload({ ...isForm, ...isPayload, [name]: value });
    } else if (name != 'phone_number') {
      setIsForm({ ...isForm, [name]: value });
      setIsPayload({ ...isForm, ...isPayload, [name]: value });
    }
  };

  const handleSubmitChangePassword = (e) => {
    e.preventDefault();

    const data = {
      password: passwordForm.passwordLama,
      new_password: passwordForm.passwordBaru,
    };

    API_PUT_MAMBOO.update
      .changePassword(data)
      .then(() => {
        setPasswordForm({
          passwordLama: "",
          passwordBaru: "",
          ulangiPasswordBaru: "",
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <>
      <div className="frame-lainnya-password">
        {informasiLainnya ? (
          <div className="informasi-lainnya" style={style}>
            <div className="text-lainnya">Informasi Lainnya</div>
            {addComponentTop}
            <div className="frame-lainnya">
              <div className="text-alamat">
                {textAlamat ? textAlamat : "*Alamat Rumah"}
              </div>
              <FormInputs
                placeholder={
                  textAlamat
                    ? "Masukkan alamat sesuai KTP"
                    : "Masukkan alamat surat menyurat"
                }
                className="frame-wrapper"
                name="address"
                value={isForm.address}
                onChange={onChangeFormLainnya}
              />
            </div>
            <div className="frame-lainnya"> 
              <div className="text-telepon">*Telepon/Hp</div>
              <FormInputs
                placeholder="0812-xxx-xxx"
                className="frame-wrapper"
                name="phone_number"
                value={isForm.phone_number}
                onChange={onChangeFormLainnya}
              />
            </div>
            {addComponentBottom}
          </div>
        ) : null}
        {password ? (
          <div className="ubah-password">
            <div className="text-lainnya">Ubah Password</div>
            {isPasswordLabel.map((val) => {
              return (
                <>
                  <div className="frame-lainnya">
                    <CustomInput
                      className="frame-input-custom"
                      label={val.label}
                      name={val.name}
                      placeholder={val.placeholder}
                      onChange={onChange}
                      value={passwordForm[val.name]}
                      type={`${isPasswordShow[val.name] ? "text" : "password"}`}
                      Icon={isPasswordShow[val.name] ? Eye : EyeOff}
                      // iconPosition="right"
                      iconAction={() => passwordIconAction(val.name)}
                      error={inputError[val.name]}
                    />
                  </div>
                </>
              );
            })}
            <CustomButton
              label="Ubah Password"
              color={isDisabled ? "secondary-btn" : "primary-btn"}
              className="btn-password"
              disabled={isDisabled}
              onClick={handleSubmitChangePassword}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default LainnyaAndPassword;
